<template>
  <div>
    <CardedSectionHeader
      icon="mdi-plus"
      :label="
        is_editing
          ? 'Edit Promotion Featuring Form'
          : 'Promotion Featuring Form'
      "
      id="admin_promotions_feature_form_section"
    ></CardedSectionHeader>
    <div class="white text-left pl-10 pt-2 pb-2">
      <h4 v-if="progress == 1">
        STEP 1 :<span class="info--text">
          Please First Select The Promotion To Feature
        </span>
      </h4>
      <h4 v-if="progress == 2">
        STEP 2 :<span class="info--text">
          Fill the form below to feature the selected promotion
        </span>
      </h4>
    </div>
    <div v-show="progress == 1">
      <AdminPromotionsList
        :is_loading="is_loading"
        :is_adding_promotion="true"
        @on-selected-promotion="on_selected_promotion"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
        @on-loaded-promotions="on_loaded_promotions"
        ref="admin_promotions_list_cmp_ref"
        @on-auto-fill-selected-first-item="on_auto_fill_selected_first_item"
      ></AdminPromotionsList>
    </div>
    <div v-if="progress == 2 && selected_promotion != null">
      <CardedForm
        ref="admin_featured_promotions_form_ref"
        id="admin_featured_promotions_form"
        title="_"
        :is_loading="is_loading"
        @on-submit-form="submit"
        :errors="errors"
        :message="message"
        @on-auto-fill="on_auto_fill"
        @on-close-message="on_hide_message"
      >
        <TextField
          v-model="selected_promotion.title"
          :validation_rules="[]"
          label="Selected Promotion"
          icon="mdi-pen-plus"
          :disabled="true"
        ></TextField>
        <v-row no-gutterss class="pa-0 mb-0">
          <v-col no-gutters class="pb-0 pt-0 mb-0">
            <TextField
              v-model="selected_promotion.business.name"
              :validation_rules="[]"
              label="Business"
              icon="mdi-pen-plus"
              :disabled="true"
            ></TextField>
          </v-col>
          <v-col no-gutters class="pb-0 pt-0 mb-0">
            <SelectField
              v-model="form.platform"
              :options="platforms"
              :small_chips="false"
              :validation_rules="form_validations.platform"
              label="Select Target Platform"
              icon="mdi-pen-plus"
              :disabled="is_loading"
              item_text="label"
              item_value="name"
            ></SelectField>
          </v-col>
        </v-row>
        <v-row no-gutterss class="pa-0 mb-0">
          <v-col no-gutters class="pb-0 pt-0 mb-0">
            <SelectField
              v-model="form.page"
              :options="pages"
              :small_chips="false"
              :validation_rules="form_validations.page"
              label="Select Target Page"
              icon="mdi-pen-plus"
              :disabled="is_loading"
              item_text="label"
              item_value="name"
            ></SelectField>
          </v-col>
          <v-col no-gutters class="pb-0 pt-0 mb-0">
            <SelectField
              v-model="form.section"
              :options="sections"
              :small_chips="false"
              :validation_rules="form_validations.section"
              label="Select Target Page Section"
              icon="mdi-pen-plus"
              :disabled="is_loading"
              item_text="label"
              item_value="name"
            ></SelectField>
          </v-col>
        </v-row>
        <template v-slot:clearbtnslot>
          <v-btn
            class="hgt-40 round-4"
            tile
            filled
            ripple
            color="success"
            @click="on_change_selected_promo"
            :disabled="is_loading || is_editing"
          >
            Change Promotion
          </v-btn>
        </template>
      </CardedForm>
    </div>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import page_info from "../../../lib/page_info";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import SelectField from "../../../components/SelectField";
import TextField from "../../../components/TextField";
import AdminPromotionsList from "./AdminPromotionsList";
export default {
  name: "AdminPromotionsFeaturedAdd",
  components: {
    CardedSectionHeader,
    CardedForm,
    SelectField,
    TextField,
    AdminPromotionsList,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
    featured_promotion_editing: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data: function () {
    return {
      cmp_user: null,
      errors: [],
      message: "",
      form: {
        promotion_id: null,
        business_id: null,
        user_id: 0,
        platform: "",
        page: "",
        section: "",
      },
      form_validations: {
        promotion_id: [Utils.validate.is_required("Promotion is required")],
        business_id: [Utils.validate.is_required("Business is required")],
        user_id: [Utils.validate.is_required("Business Owner is required")],
        platform: [
          Utils.validate.is_required("Target Platform is required"),
          Utils.validate.min_max_length(
            3,
            300,
            "Platform has to be between 3 and 300 characters long"
          ),
        ],
        page: [
          Utils.validate.is_required("Target Page is required"),
          Utils.validate.min_max_length(
            3,
            300,
            "Page has to be between 3 and 300 characters long"
          ),
        ],
        section: [
          Utils.validate.is_required("Section is required"),
          Utils.validate.min_max_length(
            3,
            300,
            "Section has to be between 3 and 300 characters long"
          ),
        ],
      },
      progress: 1,
      selected_promotion: null,
      platforms: page_info.ad_platforms,
      force_key: 1,
    };
  },
  methods: {
    on_auto_fill_selected_first_item(item) {
      this.selected_promotion = item;
      //console.log("Iam called from here Stanley: ", this.selected_promotion);
      this.form.promotion_id = this.selected_promotion.id;
      this.form.business_id = this.selected_promotion.business_id;
      this.form.user_id = this.selected_promotion.user_id;
      this.form.platform = "";
      this.form.page = "";
      this.form.section = "";
      if (this.platforms.length > 0) {
        this.form.platform = this.platforms[0].name;
        if (this.platforms[0].pages.length > 0) {
          this.form.page = this.platforms[0].pages[0].name;
          if (this.platforms[0].pages[0].sections.length > 0) {
            this.form.section = this.platforms[0].pages[0].sections[0].name;
          }
        }
      }
      this.progress = 2;
    },
    on_auto_fill() {
      if (this.is_editing == true) {
        this.init_edit_form();
      } else {
        this.$refs.admin_promotions_list_cmp_ref.auto_fill_select_first_item();
      }
      this.errors = [];
      this.message = "";
      this.$refs.admin_featured_promotions_form_ref.on_clear_validations();
    },
    init_edit_form_arg(featured_promotion_editing) {
      // this.selected_promotion = featured_promotion_editing.promotion;
      // console.log("Iam called from here Mike: ", this.selected_promotion);
    },
    init_edit_form() {
      this.selected_promotion = this.featured_promotion_editing.promotion;
      this.selected_promotion.business = this.featured_promotion_editing.promotion.business;
      this.form.business_id = this.featured_promotion_editing.business_id;
      this.form.promotion_id = this.featured_promotion_editing.promotion_id;
      this.form.user_id = this.featured_promotion_editing.user_id;
      this.form.platform = this.featured_promotion_editing.platform;
      this.form.page = this.featured_promotion_editing.page;
      this.form.section = this.featured_promotion_editing.section;

      this.errors = [];
      this.message = "";
      this.progress = 2;
      if(this.$refs.admin_featured_promotions_form_ref){
        this.$refs.admin_featured_promotions_form_ref.on_clear_validations();
      }
    },
    init_form() {
      if (this.is_editing == false) {
        this.form.promotion_id = 0;
        this.form.business_id = 0;
        this.form.user_id = 0;
        this.platform = "";
        this.page = "";
        this.section = "";
        this.progress = 1;
        this.selected_promotion = Utils.get_default_promotion();
        //console.log("Iam called from here Peter: ", this.selected_promotion);
      } else {
        this.selected_promotion = this.featured_promotion_editing.promotion;
        //console.log("Iam called from here Paul: ", this.selected_promotion);
        this.selected_promotion.business = this.featured_promotion_editing.promotion.business;

        this.form.promotion_id = this.featured_promotion_editing.promotion.id;
        this.form.business_id = this.featured_promotion_editing.business_id;
        this.form.user_id = this.featured_promotion_editing.user_id;
        this.form.platform = this.featured_promotion_editing.platform;
        this.form.page = this.featured_promotion_editing.page;
        this.form.section = this.featured_promotion_editing.section;
        this.progress = 2;
        //console.log("This other one ", this.form, this.featured_promotion_editing);
      }
      this.errors = [];
      this.message = "";
      this.$refs.admin_featured_promotions_form_ref.on_clear_validations();
    },
    submit() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      if (this.is_editing == false) {
        ServerClient.Promotions.post_fetaured_promotion(
          this.form,
          (res) => {
            this.$emit("on-hide-loader");
            this.message =
              "<b>Operation was successfull</b> <br/>  The promotion has been fetaured successfully";
            this.$refs.admin_featured_promotions_form_ref.show_message_dialog();
          },
          (errors) => {
            this.$emit("on-hide-loader");
            this.errors = errors;
            this.$refs.admin_featured_promotions_form_ref.show_error_dialog();
          }
        );
      }else{
        ServerClient.Promotions.update_fetaured_promotion({
            data: this.form,
            id: this.featured_promotion_editing.id
          },
          (res) => {
            this.$emit("on-hide-loader");
            this.message =
              "<b>Operation was successfull</b> <br/>  The promotion fetauring was updated successfully";
            this.$refs.admin_featured_promotions_form_ref.show_message_dialog();
          },
          (errors) => {
            this.$emit("on-hide-loader");
            this.errors = errors;
            this.$refs.admin_featured_promotions_form_ref.show_error_dialog();
          }
        );
      }
    },
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-success-edit-featuring");
      } else {
        this.init_form();
      }
    },
    on_selected_promotion(promotion) {
      this.selected_promotion = promotion;
      //console.log("Iam called from here Nelson: ", this.selected_promotion);
      this.form.promotion_id = promotion.id;
      this.form.business_id = promotion.business_id;
      this.form.user_id = promotion.user_id;
      this.progress = 2;
    },
    on_change_selected_promo() {
      this.selected_promotion = Utils.get_default_promotion();
      //console.log("Iam called from here Ivan: ", this.selected_promotion);
      this.progress = 1;
    },
    on_loaded_promotions() {
      if (this.is_editing == true) {
        this.init_edit_form();
      } else {
        this.init_form();
      }
    },
  },
  computed: {
    pages() {
      var lst = [];
      for (let index = 0; index < this.platforms.length; index++) {
        var platform = this.platforms[index];
        if (platform.name == this.form.platform) {
          lst = platform.pages;
        }
      }
      return lst;
    },
    sections() {
      var lst = [];
      for (let index = 0; index < this.pages.length; index++) {
        var page = this.pages[index];
        if (page.name == this.form.page) {
          lst = page.sections;
        }
      }
      return lst;
    },
  },
  mounted() {
    this.cmp_user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not or they are not admins there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Feature Promotions",
      crumps: [
        {
          text: "admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "Feature",
          disabled: true,
          href: "/adin/promotions/add/featured",
        },
      ],
      navbar_cols: 3,
    });

    if (this.is_editing) {
      this.selected_promotion = this.featured_promotion_editing.promotion;
      this.selected_promotion.business = this.featured_promotion_editing.promotion.business;
      this.form.business_id = this.featured_promotion_editing.business_id;
      this.form.promotion_id = this.featured_promotion_editing.promotion_id;
      this.form.user_id = this.featured_promotion_editing.user_id;
      this.form.platform = this.featured_promotion_editing.platform;
      this.form.page = this.featured_promotion_editing.page;
      this.form.section = this.featured_promotion_editing.section;
      this.progress = 2;
      this.init_edit_form();
      //console.log("zanyisa",this.selected_promotion);
    }
  },
};
</script>